/**
 * Bitmap pack: all PNG files of a bundle's BitmapDefs concatenated into one file so a bundle loads with a single
 * request instead of one per bitmap (the obj bundle alone has 1398; over a high-latency link the per-file round
 * trips dominated start-up). The PNG bytes are stored unchanged, so decoded pixels are identical.
 *
 * Layout: "FWPK" | uint32 LE json length | UTF-8 JSON {"entries": {"bitmaps/<id>.png": [offset, length]}} | data.
 * Offsets are relative to the start of the data section.
 */
export interface BitmapPack {
  entries: Record<string, [number, number]>;
  data: Uint8Array;
}

export const BITMAP_PACK_MAGIC = 'FWPK';

export function parseBitmapPack(bytes: Uint8Array): BitmapPack {
  if (bytes.length < 8 || String.fromCharCode(bytes[0], bytes[1], bytes[2], bytes[3]) !== BITMAP_PACK_MAGIC) throw new Error('Not a bitmap pack');
  const len = bytes[4] | (bytes[5] << 8) | (bytes[6] << 16) | (bytes[7] << 24);
  const json = JSON.parse(new TextDecoder().decode(bytes.subarray(8, 8 + len))) as { entries: Record<string, [number, number]> };
  return { entries: json.entries, data: bytes.subarray(8 + len) };
}

/** Bytes of one packed file (a view, no copy). */
export function packEntry(pack: BitmapPack, rel: string): Uint8Array | null {
  const e = pack.entries[rel];
  return e ? pack.data.subarray(e[0], e[0] + e[1]) : null;
}
